import { Box, LinearProgress } from '@mui/material';
import React, { FC } from 'react';

interface IUploadNft {
  value: number;
  description: string;
  uploadingItem: string;
}

const h1Styles = {
  color: 'white',
  margin: '10px',
  textAlign: 'center',
} as React.CSSProperties;

const h4Styles = {
  fontSize: '1rem',
  textAlign: 'center',
  color: 'white',
} as React.CSSProperties;

const h3Styles = {
  color: 'white',
  marginTop: '40px',
  textAlign: 'center',
  fontWeight: 400,
} as React.CSSProperties;

const UploadNft: FC<IUploadNft> = ({ value, uploadingItem, description }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: '60%',
      }}
    >
      <h1 style={h1Styles}>Uploading your {uploadingItem}</h1>
      <h4 style={h4Styles}>Please wait</h4>
      <h3 style={h3Styles}>{description}</h3>
      <LinearProgress
        sx={{ marginTop: '30px', width: '100%' }}
        value={value}
        variant="determinate"
      />
      <h4 style={h3Styles}>{value}%</h4>
    </Box>
  );
};

export default UploadNft;
